import BaseModel from './BaseModel';

/** Class representing an user. */
class TktUser extends BaseModel {
    constructor(properties) {
        super(properties);

        // ensure nested contact objects exist for the form
        this.contact = this.contact || {};
        this.contact.opaque = this.contact.opaque || {};
        if (Array.isArray(this.contact.opaque))
            this.contact.opaque = Object.assign({}, this.contact.opaque);
        this.contact.address = this.contact.address || {};
        if (Array.isArray(this.contact.address))
            this.contact.address = Object.assign({}, this.contact.address);
    }

    isCustomer = () => {
        return this.roles.includes("customer");
    }

    isPihyve = () => {
        return this.roles.includes("pihyve");
    }
}

export default TktUser;
